<template>
  <table-base
    :columns="columns"
    :items="programs"
    :pagination="pagination"
    :is-loading="isLoading"
    has-custom-items-template
    :on-select-item="onSelectItem"
    :has-no-footer="true"
  >
    <template v-slot:item-cell="scope">
      <template v-if="scope.cell.column.value === 'country'">
        <PlatformPanel :country="scope.cell.item.country" />
      </template>

      <template v-else-if="scope.cell.column.value === 'status'">
        <div class="d-flex gap-16 align-start">
          <StatusPanel
            table-group="tracking"
            :status="scope.cell.item.status.name"
          />
          <StatusPanel
            v-if="displayScheduledStatus(scope.cell.item)"
            table-group="tracking"
            status="scheduled"
            class="text-no-wrap"
          >
            {{ displayScheduledStatus(scope.cell.item) }}
          </StatusPanel>
        </div>
      </template>

      <template v-else-if="scope.cell.column.value === 'tag.name'">
        <v-chip
          variant="outlined"
          v-if="displayColumnValue(scope.cell.item, 'tag.name')"
        >
          {{ displayColumnValue(scope.cell.item, 'tag.name') }}
        </v-chip>
      </template>

      <template v-else-if="scope.cell.column.value === 'targeted_path'">
        <span class="text-grey font-weight-bold">
          {{ displayColumnValue(scope.cell.item, 'targeted_path') }}
        </span>
      </template>

      <template v-else-if="scope.cell.column.value === 'network_advertiser_id'">
        <div
          class="text-end"
          style="min-width: 130px;"
        >
          {{ displayColumnValue(scope.cell.item, scope.cell.column.value) }}
        </div>
      </template>

      <template v-else>
        {{ displayColumnValue(scope.cell.item, scope.cell.column.value) }}
      </template>
    </template>
  </table-base>
</template>

<script>
import { extractNestedProp, isNum, isNonEmptyStr } from '@/utils';
import PlatformPanel from '@/components/panels/Platform.vue';
import StatusPanel from '@/components/panels/Status.vue';
import columns from '@/config/tracking/columnsPrograms';

export default {
  components: {
    PlatformPanel,
    StatusPanel,
  },
  emits: ['on-select-item', 'on-update-pagination', 'on-change-page'],
  props: {
    advertiser: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      isLoading: false,
      columns: columns,
      pagination: {
        page: 1,
        rowsPerPage: 1000,
        rowsNumber: 1000,
        totalItems: 0,
      },
    }
  },
  computed: {
    programs() {
      return this.$store.getters['tracking/advertiserPrograms'];
    },
  },
  watch: {
    advertiser: {
      handler(newAdvertiser, oldAdvertiser) {
        if (
          (isNum(newAdvertiser?.id) && newAdvertiser.id !== oldAdvertiser?.id) ||
          (this.programs.length === 0 && isNum(this.advertiser.id))
        ) {
          this.getPrograms();
        }
      },
      immediate: true,
    },
  },
  methods: {
    getPrograms() {
      this.isLoading = true;
      this.$store.dispatch('tracking/getPrograms', this.advertiser.id)
        .then((res) => {
          this.pagination.totalItems = res.length;
        })
        .catch((err) => err)
        .finally(() => {
          this.isLoading = false;
        });
    },
    displayScheduledStatus(item) {
      if (item?.status?.id === 0 && isNonEmptyStr(item.start_date)) {
        return 'Activation ' + this.formatDate(item.start_date);
      } else if (item?.status?.id === 1 && isNonEmptyStr(item.end_date)) {
        return 'Deactivation ' + this.formatDate(item.end_date);
      }
      return false;
    },
    displayStatus(item) {
      if (item?.status?.id === 2) {
        return 'Scheduled ' + this.formatDate(item.start_date);
      }
      return item.status.name;
    },
    formatDate(startDate) {
      return startDate.replace('-', '.').replace(' ', ' - ');
    },
    displayColumnValue(item, value) {
      return extractNestedProp(item, value);
    },
    onSelectItem(item) {
      this.$router.push({
        name: 'tracking-management-advertiser-program-details',
        params: {
          id: this.advertiser.id,
          programId: item.id,
        },
        query: this.$route.query,
      });
    },
    onUpdatePagination(pagination) {
      this.$emit('on-update-pagination', pagination);
    },
    onChangePage(page) {
      this.$emit('on-change-page', page);
    },
  },
};
</script>

<style lang="scss">
  .tracking-advertiser-view {
    th {
      text-wrap: nowrap;
    }
  }
</style>
